import { authReducer } from '../../authentication/reducers/AuthReducer';
import authenticationSaga from '../../authentication/sagas/AuthSaga';
const loadAuthenticationModule = () => ({
    id: 'Authentication',
    reducerMap: {
        authentication: authReducer,
    },
    sagas: [authenticationSaga],
});
export default loadAuthenticationModule;
